/**
 * ════════════════════════════════════════════════════════════
 * BESTAND: assets/shrine-cart-promo-banner.js
 * ────────────────────────────────────────────────────────────
 * 1+1 Gratis promo-banner voor Shrine Pro cart drawer.
 *
 * Strategie:
 *   • Telt cart-items met data-promo-1plus1="true" in de DOM
 *     (inclusief hun quantity via data-item-quantity).
 *   • Luistert op ALLE manieren waarop Shrine Pro de cart
 *     drawer ververst:
 *       1. Custom events die Shrine Pro zelf dispatcht
 *       2. fetch()-interceptor  (cart/add, change, update)
 *       3. XHR-interceptor      (fallback)
 *       4. MutationObserver     (herrender van drawer-content)
 *   • Voorkomt dubbele banners en dubbele evaluaties.
 * ════════════════════════════════════════════════════════════
 */

(function ShrinePromoBanner() {
  'use strict';

  /* ── CONFIGURATIE ────────────────────────────────────────── */
  var CFG = {
    /** data-attribuut op cart-item wrapper (Liquid patch) */
    DATA_ATTR: 'data-promo-1plus1',

    /** data-attribuut voor quantity op hetzelfde element */
    QTY_ATTR: 'data-item-quantity',

    /** id van het banner-element (shrine-cart-promo-banner.liquid) */
    BANNER_ID: 'shrine-promo-banner',

    /**
     * CSS-selector die de container van alle cart-item wrappers
     * aanduidt.  Shrine Pro gebruikt doorgaans één van:
     *   '.drawer__inner'  |  '[data-cart-items]'  |  '#CartItems'
     * Pas aan als jouw theme een andere class/id gebruikt.
     */
    ITEMS_CONTAINER: '[data-cart-items], .cart-items, #CartItems, .drawer__inner',

    /**
     * Shrine Pro events – we luisteren op al deze namen zodat
     * toekomstige Shrine updates ook worden opgevangen.
     */
    SHRINE_EVENTS: [
      'cart:refresh',
      'cart:updated',
      'cart:change',
      'shrine:cart:updated',
      'theme:cart:updated',
    ],

    /** Debounce-vertraging na cart-mutaties (ms) */
    DEBOUNCE_MS: 120,
  };
  /* ── EINDE CONFIGURATIE ──────────────────────────────────── */


  /* ── Debounce hulpfunctie ────────────────────────────────── */
  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }


  /* ── Telfunctie: dom-gebaseerd ───────────────────────────── */
  /**
   * Zoekt alle cart-item elementen met data-promo-1plus1="true"
   * en telt hun quantity op.
   *
   * DOM-gebaseerd tellen werkt ongeacht het AJAX-mechanisme van
   * Shrine Pro: de data-attributen zitten in de gerenderde HTML
   * die Liquid al heeft gegenereerd.
   */
  function countPromoItemsInDOM() {
    var selector = '[' + CFG.DATA_ATTR + '="true"]';
    var items = document.querySelectorAll(selector);
    var total = 0;

    items.forEach(function (el) {
      var qty = parseInt(el.getAttribute(CFG.QTY_ATTR) || '1', 10);
      if (!isNaN(qty) && qty > 0) {
        total += qty;
      }
    });

    return total;
  }


  /* ── Banner tonen / verbergen ────────────────────────────── */
  function updateBanner() {
    var banner = document.getElementById(CFG.BANNER_ID);
    if (!banner) return; // drawer nog niet in DOM

    var count = countPromoItemsInDOM();

    if (count === 1) {
      banner.removeAttribute('hidden');
    } else {
      banner.setAttribute('hidden', '');
    }
  }

  var debouncedUpdate = debounce(updateBanner, CFG.DEBOUNCE_MS);


  /* ── 1. Shrine Pro / theme custom events ─────────────────── */
  CFG.SHRINE_EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, debouncedUpdate);
  });


  /* ── 2. fetch()-interceptor ──────────────────────────────── */
  /**
   * Shrine Pro gebruikt fetch() voor cart/add, cart/change en
   * cart/update.  We wrappen window.fetch zodat we na elk van
   * deze verzoeken de banner opnieuw evalueren.
   */
  (function patchFetch() {
    var _fetch = window.fetch;

    window.fetch = function (resource) {
      var url = typeof resource === 'string'
        ? resource
        : (resource && resource.url) || '';

      var isMutation = /\/cart\/(add|change|update)(\.js)?/.test(url);
      var promise    = _fetch.apply(window, arguments);

      if (isMutation) {
        promise.then(debouncedUpdate).catch(function () {});
      }

      return promise;
    };
  })();


  /* ── 3. XHR-interceptor (fallback) ──────────────────────── */
  (function patchXHR() {
    var NativeXHR = window.XMLHttpRequest;

    function ShrineXHR() {
      var xhr       = new NativeXHR();
      var origOpen  = xhr.open.bind(xhr);
      var isMutation = false;

      xhr.open = function (method, url) {
        isMutation = /\/cart\/(add|change|update)(\.js)?/.test(url || '');
        return origOpen.apply(xhr, arguments);
      };

      xhr.addEventListener('load', function () {
        if (isMutation) debouncedUpdate();
      });

      return xhr;
    }

    /* Kopieer prototype zodat instanceof-checks blijven werken */
    ShrineXHR.prototype = NativeXHR.prototype;
    window.XMLHttpRequest = ShrineXHR;
  })();


  /* ── 4. MutationObserver ─────────────────────────────────── */
  /**
   * Shrine Pro herrendert de cart-drawer content via innerHTML
   * of via DOM-injectie na een AJAX-update.  De MutationObserver
   * vangt dit op en triggert een hercontrole.
   *
   * We observeren <body> zodat we ook de initiële injectie van
   * de drawer mee krijgen.
   */
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      /* Controleer of het banner-element of cart-items geraakt zijn */
      return (
        m.addedNodes.length > 0 ||
        (m.type === 'attributes' && (
          m.attributeName === 'hidden' ||
          m.attributeName === 'style'  ||
          m.attributeName === 'class'
        ))
      );
    });

    if (relevant) debouncedUpdate();
  });

  /* Start observatie zodra de DOM klaar is */
  function startObserver() {
    observer.observe(document.body, {
      childList: true,
      subtree:   true,
      attributes: true,
      attributeFilter: ['hidden', 'style', 'class', 'open'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }


  /* ── 5. Initiële check bij laden ─────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBanner);
  } else {
    updateBanner();
  }

})();
